import { render } from "./EmployeeDetailsPage.vue?vue&type=template&id=a745ed14"
import script from "./EmployeeDetailsPage.vue?vue&type=script&lang=ts"
export * from "./EmployeeDetailsPage.vue?vue&type=script&lang=ts"
script.render = render

export default script